import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {UnitsOfTimeType} from "../../../commons/types/units-of-time.type";

export class PricePlanPackageSizeViewCtrl implements IController {
  program: any;
  groups: any;
  programId: any;
  labelOptions: any;
  accountId: any;


  public groupKeysCopy: any;
  public currency: any;
  public unit: any;
  public distanceUnit: any;
  public packageIcons: any;
  public isDesktop: boolean;
  public isSaveAvailable: any;
  public groupKeys: any;
  public unitsOfTimeType: typeof UnitsOfTimeType = UnitsOfTimeType;

  constructor(private PricePlanService, private splitService, private orderConstants, private $mdMedia) {
    this.currency = this.splitService.getCurrencySymbol();
    this.unit = this.splitService.getWeightUnit();
    this.distanceUnit = this.splitService.getSiteDistanceSmallUnit();
    this.packageIcons = this.orderConstants.packageTypeKeys;
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {
    this._initValues();
  }

  _initValues(){
    if (!this.labelOptions) {
      this.labelOptions = [];
    }
    this.isSaveAvailable = false;
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this.groupKeysCopy = angular.copy(this.groupKeys);
  }

  onSelectedChange(packageData, packageType) {
    this.groupKeys.PackageSize[packageType].selected = !packageData.selected ? null : packageData.selected;
    if (packageData.selected) {
      _.forOwn(this.groupKeys.PackageSize, (value, key) => {
        if (packageType !== key) {
          value.selected = false;
        }
      });
    }
    this.onDataChange(this.groupKeys);
  }

  onLabelChanges(labels, size) {
    this.groupKeys.PackageSize[size].labels = labels;
    this.onDataChange(this.groupKeys);
  }

  onServiceTimePickupChange(value, size) {
    this.groupKeys.PackageSize[size].pickupServiceTimeInMillis = value;
    this.onDataChange(this.groupKeys);
  }

  onServiceTimeDropoffChange(value, size) {
    this.groupKeys.PackageSize[size].dropoffServiceTimeInMillis = value;
    this.onDataChange(this.groupKeys);
  }

  onServiceTimeOperationChange(value, size) {
    this.groupKeys.PackageSize[size].operationServiceTimeInMillis = value;
    this.onDataChange(this.groupKeys);
  }

  onServiceTimeMaxChange(value, size) {
    this.groupKeys.PackageSize[size].maxServiceTimeInMillis = value;
    this.onDataChange(this.groupKeys);
  }

  // onServiceTimeChange(value, size) {
  //   this.groupKeys.PackageSize[size].serviceTimeInMillis = value;
  //   this.onDataChange(this.groupKeys);
  // }

  onDataChange(groupKeys) {
    this.isSaveAvailable = !_.isEqual(groupKeys, this.groupKeysCopy);
  }

  onSaveProgram() {
    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeys);
    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
        this._initValues();
      })
  }

  onCancelChanges(){
    this.groupKeys = angular.copy(this.groupKeysCopy);
    this.isSaveAvailable = false;
    this.onDataChange(this.groupKeys);
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanPackageSizeView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      labelOptions: '<',
      accountId: '<?'
    },
    template: require('./price-plan-package-size-view.html').default,
    controller: PricePlanPackageSizeViewCtrl
  });
